import {
    REQUEST_UPDATE_PRICE_RATE,
    REQUEST_UPDATE_PRICE_RATE_FAILURE,
    REQUEST_UPDATE_PRICE_RATE_SUCCESS
} from "../../../constant/PriceRateConstant";


const initialState = {
    updatePriceRate: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const updatePriceRateReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_UPDATE_PRICE_RATE:
            return {
                ...state,
                updatePriceRate: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_UPDATE_PRICE_RATE_SUCCESS:
            return {
                ...state,
                updatePriceRate: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_UPDATE_PRICE_RATE_FAILURE:
            return {
                ...state,
                updatePriceRate: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
